import { format } from 'date-fns'

import { CHARACTER_WHITESPACE } from '../../../../../constants/common'
import { DATE_API_DATA_FORMAT_SHORT } from '../../../../../constants/date'
import { toUkTimezoneDate } from '../../../../../utils/date'
import { TASK_FORM_DEADLINE_FIELD_NAME } from '../../../../Task'
import { getCalendarCapWarningText } from '../../../Calendar.utils'

export function getCalendarTaskMoveDate({ timezone, values }) {
  const deadline = values[TASK_FORM_DEADLINE_FIELD_NAME]

  return deadline
    ? format(toUkTimezoneDate(deadline, timezone), DATE_API_DATA_FORMAT_SHORT)
    : null
}

export function getCalendarTaskMoveDayLoadWarning({ dayLoad, locale, t }) {
  return [
    getCalendarCapWarningText({ dayLoad, locale, t }),
    t('Calendar.MoveTasksDontCountKey'),
  ].join(CHARACTER_WHITESPACE)
}
